import React, { useState, useEffect, useRef } from "react";
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
import { ModalTrasladoFondos } from "./modalSolicitudTraladoFondos";
import { formatMoneda } from "../../util/varios";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const TablaSolicitudTrasladoFondos = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob] = useState(null);
  const [values, setValues] = useState();
  const [aprobaciones] = useState();
  const [aprodetalle] = useState();
  const [norden] = useState(true);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              (x.idaprobacion !== null
                ? x.idaprobacion
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "") ||
              (x.descripaprobacion !== null
                ? x.descripaprobacion
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "") ||
              (x.fecha !== null
                ? moment.utc(x.fecha)
                  .format("DD/MM/YYYY")
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : "") ||
              (x.montototalaprob !== null
                ? formatMoneda(
                  x.montototalaprob
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                ).includes(target.value)
                : "")
            ) {
              return x;
            }
          });
      },
    });
  };

  const seleccionarRegistros = () => {
    setMostrar2(false);
    let endpoint = `${op.conexion}/api/administracion/catalogoaprobtraslafondotercero?idefiscal=${idefiscal}&stat=0&desde=0`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: `${error}`,
          icono: "error",
        });
      });
  };
  const handleCloseSi = () => {
    setActivate(false);
  };
  const gestionarSolicituTraslado = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      setValues(data);
      setMostrar2(true);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      if (data.status === 1) {
        setMensaje({
          mostrar: true,
          titulo: "información",
          texto: "La solicitud ya fue aprobada.",
          icono: "informacion",
        });
        return;
      }

      setOperacion(op);
      setValues(data);
      setMostrar2(true);
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);
  const handleCancelar = () => {
    setMostrar2(false);
  };
  const cerrar = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-white rounded-top">
        <h3 className="m-0">Gestionar Solicitud de Fondos de Terceros</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="col-12 m-0 p-2 d-flex justify-content-between"
      >
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
            className='search-input form-control form-control-sm' />
        </div>
        <PrimaryButton
          onClick={gestionarSolicituTraslado(1, "")}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.idaprobacion}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "300px",
                    }}
                  >
                    {item.descripaprobacion}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {moment.utc(item.fecha).format("DD/MM/YYYY")}
                  </td>

                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {formatMoneda(
                      item.montototalaprob
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionarSolicituTraslado(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      onClick={gestionarSolicituTraslado(2, item)}
                      className="btn btn-sm mx-1 btn-success rounded-circle"
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalTrasladoFondos
        show={mostrar2}
        operacion={operacion}
        norden={norden}
        aprobado={aprob}
        ubi={44}
        tip={0}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        titulo={
          operacion === 4
            ? "Consultar Orden Pago"
            : operacion === 2
              ? "Reversar Orden Pago"
              : operacion === 1
                ? "Incluir Orden Pago"
                : "Eliminar Orden Pago"
        }
        onHideCancela={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
        values={values}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaSolicitudTrasladoFondos;
